import React from "react"
import { useTranslation } from "react-i18next"

import { Layout } from "~/components/Layout/Layout"

import { Contacts } from "./components/Contacts/Contacts"
import { Dividends } from "./components/Dividends/Dividends"
import { Hero } from "./components/Hero/Hero"
import { Quotations } from "./components/Quotations/Quotations"
import { Structure } from "./components/Structure/Structure"

const Stock: React.FC = () => {
  const { t } = useTranslation()

  return (
    <Layout description={t("stock.Hero.Lead")} headerTheme="onDark" title={t("page.stock")}>
      <Hero />
      <Structure />
      <Quotations />
      <Dividends />
      <Contacts />
    </Layout>
  )
}

export default Stock
